<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <Loading v-if="loading" :text="$t('finish-loading')"></Loading>
      <CalculatorHeading></CalculatorHeading>
      <h3 v-if="error">{{ error }}</h3>
      <div v-if="calcData" class="wrapper">
        <div class="cost">
          <h3 class="cost-label">{{ $t("estimated-cost") }}</h3>
          <div class="cost-number">{{ cost.toLocaleString() }} €</div>

          <h4 style="padding-top: 15px">
            {{ $t("summary.report-body") }}
          </h4>
          <div class="report-form">
            <input
              type="email"
              name="email"
              class="email-input"
              v-model="email"
              :placeholder="$t('summary.your-email')"
            />
            <one-button
              type="primary"
              class="email-submit-btn"
              @click="sendReportEmail()"
            >
              {{ $t("summary.get-report-btn") }}
            </one-button>
            <div class="email-error">{{ emailError }}</div>
            <div class="email-success">{{ emailSuccess }}</div>
          </div>
          <div class="report-title">
          <!-- Last character is an emoji... can't be seen by Webstorm!-->
            {{ $t("summary.report-title") }}
            <span class="hand-right">👉</span>
          </div>
        </div>
        <div>
          <CalendlyCall></CalendlyCall>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/blocks/Loading";
import CalculatorHeading from "../components/CalculatorHeading";
import { BACKEND_URL } from "@/utils/config";
import { localizeUrl } from "@/utils/localizeUrl";
import CalendlyCall from "../components/CalendlyCall";
const axios = require("axios").default;

export default {
  name: "Finish",
  components: {CalendlyCall, CalculatorHeading, Loading },
  data() {
    return {
      dataId: null,
      loading: true,
      error: null,
      cost: null,
      calcData: null,
      email: "",
      emailError: null,
      emailSuccess: null
    };
  },
  mounted() {
    this.dataId = this.$route.query.id;
    if (!this.dataId) {
      this.loading = false;
      this.error = this.$t("summary.no-summary-found");
      setTimeout(
        () => this.$router.push(localizeUrl(`/`, this.$i18n.locale)),
        4000
      );
      return;
    }
    this.getData(this.dataId);
  },
  methods: {
    async getData(id) {
      try {
        const resp = await axios.get(BACKEND_URL + `/calculator-data?id=${id}`);
        if (resp.status !== 200) {
          throw new Error(resp.status);
        }
        this.calcData = resp.data;
        this.cost = resp.data.totalCost;
      } catch (error) {
        this.error = this.$t("summary.something-went-wrong");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async sendReportEmail() {
      this.emailError = null;
      this.emailSuccess = null;
      if (!this.validateEmail(this.email)) {
        this.emailError = this.$t("summary.email-not-valid");
        return;
      }
      try {
        this.emailSuccess = this.$t("summary.email-sending");
        const resp = await axios.post(BACKEND_URL + `/send-report`, {
          dataId: this.dataId,
          email: this.email,
          lang: this.$i18n.locale
        });
        if (resp.status !== 200) {
          throw new Error(resp.status);
        }
        this.emailSuccess = this.$t("summary.email-success");

        await this.$router.push(localizeUrl("thank-you", this.$i18n.locale));
      } catch (error) {
        this.emailSuccess = null;
        this.emailError = this.$t("summary.email-fail");
        console.error(error);
      }
    },
    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 60px;
}
.cost {
  flex-grow: 1;
  flex-basis: 0;
  text-align: left;
  justify-content: center;
  margin-right: 40px;
}
.work-with-us {
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cost-number {
  font-size: 64px;
  font-weight: bold;
}
.cost-label {
  font-weight: 800;
  margin-bottom: 0px;
}
.report-title {
  font-size: 36px;
  font-weight: bold;
  font-family: $font-secondary;
}
.email-input {
  font-family: $font-primary;
  margin: 0 0 10px 0;
  border-radius: 25px;
  border: 1px solid #999;
  padding: 9px;
  width: 200px;
}
.email-submit-btn {
  margin: 0 10px 0 10px;
}
.report-form {
  margin-top: 30px;
  margin-bottom: 60px;
}
.work-with-us-img {
  max-width: 300px;
  margin-top: 40px;
}
.work-with-us-btn {
  margin-top: 30px;
}

.hand-right {
  display: inline-block;
}

@media only screen and (max-width: 960px) {
  .hand-right {
    display: none;
  }

  .wrapper {
    display: unset;
  }
  .cost {
    text-align: center;
    margin-right: 0;
  }
  .work-with-us {
    img {
      width: 100%;
    }
    margin: 0 20px 40px 20px;
    > h4 {
      padding: 0 20px 0 20px;
    }
  }

  .report-title {
    margin-bottom: 50px;
  }
}

.email-error {
  padding-top: 10px;
  color: $color-error;
}
.email-success {
  color: $color-success;
}

@keyframes pulse_animation {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.03);
  }
  60% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}
.pulse {
  animation-name: pulse_animation;
  animation-duration: 2000ms;
  transform-origin: 50% 50%;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>
